import { addCommaBetweenTextField } from '@/utils';
import { FormDataHubAdjustmentTaxInvoice } from '@/form/form-data/FormDataHubAdjustmentTaxInvoice';
import { objDeepCompare } from '@/utils/object';
const getters = {
    // 다이얼로그 열림 여부
    isDialogOpen: ({ dialogDetail }) => !!dialogDetail.id,
    // dialog Chip for status
    dialogStatusChip: ({ taxInvoiceData }) => taxInvoiceData?.statusChipData,
    status: ({ taxInvoiceData }) => taxInvoiceData?.status,
    getterInvoicerFormDataAddress: ({ invoicerFormData }) => {
        const { siDo, siGunGu, eupMyeonDong, ri, landNumber, roadName, buildingNumber, buildingName, } = invoicerFormData.address;
        const addressList = [
            siDo,
            siGunGu,
            eupMyeonDong,
            ri,
            landNumber,
            roadName,
            buildingNumber,
            buildingName,
        ];
        return addCommaBetweenTextField(addressList, false);
    },
    getterIsFormChanged: ({ taxInvoiceData, invoicerFormData, isEditMode, }) => {
        if (!isEditMode) {
            return false;
        }
        if (!taxInvoiceData?._taxInvoice) {
            return false;
        }
        const initialData = new FormDataHubAdjustmentTaxInvoice();
        initialData.initFormData(taxInvoiceData?._taxInvoice);
        const currentData = invoicerFormData;
        return !objDeepCompare(initialData, currentData);
    },
};
export default getters;
